export default __webpack_public_path__ + "static/media/real-estate-mini-bg.243b0498.png";